import mutations from './eprofileAktProblemak.mutations'
import actions from './eprofileAktProblemak.actions'
import getters from './eprofileAktProblemak.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
